import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

// Clon de SwitchPage/response-context para la fuente tuvocación:
//  - endpoint /api/tuvocacion/response (proxy REST, sin GraphQL legacy)
//  - autorización por firma HMAC `t` (la verifica tuvocación)
//  - el worker responde JSON plano (sin el doble-stringify de AppSync);
//    `data.data` (blob) y `campaign.metadata` siguen siendo JSON strings.

const INITIAL_VALUES = {};

const DataContext = createContext(INITIAL_VALUES);

const isJsonValue = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const DataProvider = props => {
  const { children, id, sig, initial } = props;
  const [state, setState] = useState(initial || INITIAL_VALUES);
  const [userData, setUserData] = useState(null);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getRespData = async () => {
      try {
        const { data } = await axios.get('/api/tuvocacion/response', {
          params: { id, t: sig }
        });
        const parsedData = data.data;
        const campaign = parsedData.campaign;
        if (parsedData.data) {
          parsedData.data = isJsonValue(parsedData.data)
            ? JSON.parse(parsedData.data)
            : parsedData.data;
        }
        if (campaign && campaign.metadata) {
          campaign.metadata = isJsonValue(campaign.metadata)
            ? JSON.parse(campaign.metadata)
            : campaign.metadata;
          parsedData.campaign = campaign;
        }
        await setResponse(parsedData);
      } catch (err) {
        await setResponse(null);
      }
      await setLoading(false);
    };
    getRespData();
  }, [id, sig]);

  return (
    <DataContext.Provider
      value={{
        ...state,
        updateContext: setState,
        response,
        isLoading: loading,
        userData,
        setUserData
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const DataConsumer = DataContext.Consumer;
export const useDataContext = () => useContext(DataContext);
